import { createSlice, PayloadAction } from "@reduxjs/toolkit";

//App
import { SearchDefaultValue, SearchValue } from "./types";
import { LookupGroupStoreState } from "../types/lookupGroup";

const initialState: LookupGroupStoreState = {
  searchValue: SearchDefaultValue,
  isActive: true,
};

export const lookupgroup = createSlice({
  name: "lookupgroup",
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<SearchValue>) => {
      state.searchValue.name = action.payload.name;
    },
    setIsActive: (state) => {
      state.isActive = !state.isActive;
    },
  },
});

export const { setSearchValue, setIsActive } = lookupgroup.actions;

export const selectSearchValue = (state: {
  lookupgroup: LookupGroupStoreState;
}) => state?.lookupgroup?.searchValue;
export const selectIsActive = (state: { lookupgroup: LookupGroupStoreState }) =>
  state?.lookupgroup?.isActive;

export default lookupgroup.reducer;
